import React from 'react';
import Marquee from 'react-fast-marquee';
import { BELIEF, MARQUEE_WORDS } from '../../data/content';
import { LineRevealOnView, Reveal } from './Reveal';

export const Belief = () => (
  <section className="border-t border-teal/10">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-9 md:py-14">
      <div className="grid grid-cols-12 gap-y-5">
        <div className="col-span-12 md:col-span-3">
          <Reveal>
            <span className="text-xs tracking-[0.3em] uppercase text-klein font-semibold">
              {BELIEF.overline}
            </span>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-9">
          <LineRevealOnView
            lines={['FROM VENDORS', 'TO PARTNERS.']}
            lineClassName="font-serif uppercase text-teal text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-[-0.01em]"
            stagger={0.12}
          />

          <Reveal delay={0.1}>
            <div className="mt-6 relative overflow-hidden w-full h-[240px] md:h-[340px] shadow-[0_28px_70px_-30px_rgba(4,37,42,0.4)] ring-1 ring-teal/5">
              <img
                src={BELIEF.image}
                alt=""
                className="editorial-img w-full h-full object-cover object-center"
              />
            </div>
          </Reveal>

          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl">
            {BELIEF.paragraphs.map((p, i) => (
              <Reveal key={i} delay={i * 0.12}>
                <p className="text-lg md:text-xl font-light leading-relaxed text-ink/80">{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <p className="mt-6 font-serif italic text-teal text-3xl sm:text-4xl lg:text-5xl leading-tight">
              This isn't networking. <span className="text-klein">It's world-building.</span>
            </p>
          </Reveal>
        </div>
      </div>
    </div>

    {/* Slow editorial marquee */}
    <div className="border-y border-teal/10 py-4 md:py-5 overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-teal/85 text-3xl sm:text-5xl lg:text-6xl px-8 md:px-14">
              {w}
            </span>
            <span className="text-klein text-2xl md:text-4xl">&mdash;</span>
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
